export interface Country {
	name: string;
	iso2: string;
	dialCode: string;
	flag: string;
}

export const COUNTRIES_FR = [
  { name: 'Afghanistan', iso2: 'AF', dialCode: '+93', flag: 'af' },
  { name: 'Afrique du Sud', iso2: 'ZA', dialCode: '+27', flag: 'za' },
  { name: 'Albanie', iso2: 'AL', dialCode: '+355', flag: 'al' },
  { name: 'Algérie', iso2: 'DZ', dialCode: '+213', flag: 'dz' },
  { name: 'Allemagne', iso2: 'DE', dialCode: '+49', flag: 'de' },
  { name: 'Andorre', iso2: 'AD', dialCode: '+376', flag: 'ad' },
  { name: 'Angola', iso2: 'AO', dialCode: '+244', flag: 'ao' },
  { name: 'Anguilla', iso2: 'AI', dialCode: '+1 264', flag: 'ai' },
  { name: 'Antigua-et-Barbuda', iso2: 'AG', dialCode: '+1 268', flag: 'ag' },
  { name: 'Arabie saoudite', iso2: 'SA', dialCode: '+966', flag: 'sa' },
  { name: 'Argentine', iso2: 'AR', dialCode: '+54', flag: 'ar' },
  { name: 'Aruba', iso2: 'AW', dialCode: '+297', flag: 'aw' },
  { name: 'Australie', iso2: 'AU', dialCode: '+61', flag: 'au' },
  { name: 'Autriche', iso2: 'AT', dialCode: '+43', flag: 'at' },
  { name: 'Azerbaïdjan', iso2: 'AZ', dialCode: '+994', flag: 'az' },
  { name: 'Bahamas', iso2: 'BS', dialCode: '+1 242', flag: 'bs' },
  { name: 'Bahreïn', iso2: 'BH', dialCode: '+973', flag: 'bh' },
  { name: 'Bangladesh', iso2: 'BD', dialCode: '+880', flag: 'bd' },
  { name: 'Barbade', iso2: 'BB', dialCode: '+1 246', flag: 'bb' },
  { name: 'Bélarus', iso2: 'BY', dialCode: '+375', flag: 'by' },
  { name: 'Belgique', iso2: 'BE', dialCode: '+32', flag: 'be' },
  { name: 'Belize', iso2: 'BZ', dialCode: '+501', flag: 'bz' },
  { name: 'Bénin', iso2: 'BJ', dialCode: '+229', flag: 'bj' },
  { name: 'Bermudes', iso2: 'BM', dialCode: '+1 441', flag: 'bm' },
  { name: 'Bhoutan', iso2: 'BT', dialCode: '+975', flag: 'bt' },
  { name: 'Bolivie', iso2: 'BO', dialCode: '+591', flag: 'bo' },
  { name: 'Bosnie-Herzégovine', iso2: 'BA', dialCode: '+387', flag: 'ba' },
  { name: 'Botswana', iso2: 'BW', dialCode: '+267', flag: 'bw' },
  { name: 'Brésil', iso2: 'BR', dialCode: '+55', flag: 'br' },
  { name: 'Brunei', iso2: 'BN', dialCode: '+673', flag: 'bn' },
  { name: 'Bulgarie', iso2: 'BG', dialCode: '+359', flag: 'bg' },
  { name: 'Burkina Faso', iso2: 'BF', dialCode: '+226', flag: 'bf' },
  { name: 'Burundi', iso2: 'BI', dialCode: '+257', flag: 'bi' },
  { name: 'Cambodge', iso2: 'KH', dialCode: '+855', flag: 'kh' },
  { name: 'Cameroun', iso2: 'CM', dialCode: '+237', flag: 'cm' },
  { name: 'Canada', iso2: 'CA', dialCode: '+1', flag: 'ca' },
  { name: 'Cap-Vert', iso2: 'CV', dialCode: '+238', flag: 'cv' },
  { name: 'Chili', iso2: 'CL', dialCode: '+56', flag: 'cl' },
  { name: 'Chine', iso2: 'CN', dialCode: '+86', flag: 'cn' },
  { name: 'Chypre', iso2: 'CY', dialCode: '+357', flag: 'cy' },
  { name: 'Colombie', iso2: 'CO', dialCode: '+57', flag: 'co' },
  { name: 'Comores', iso2: 'KM', dialCode: '+269', flag: 'km' },
  { name: 'Corée du Nord', iso2: 'KP', dialCode: '+850', flag: 'kp' },
  { name: 'Corée du Sud', iso2: 'KR', dialCode: '+82', flag: 'kr' },
  { name: 'Costa Rica', iso2: 'CR', dialCode: '+506', flag: 'cr' },
  { name: 'Côte d\'Ivoire', iso2: 'CI', dialCode: '+225', flag: 'ci' },
  { name: 'Croatie', iso2: 'HR', dialCode: '+385', flag: 'hr' },
  { name: 'Cuba', iso2: 'CU', dialCode: '+53', flag: 'cu' },
  { name: 'Curaçao', iso2: 'CW', dialCode: '+599', flag: 'cw' },
  { name: 'Danemark', iso2: 'DK', dialCode: '+45', flag: 'dk' },
  { name: 'Djibouti', iso2: 'DJ', dialCode: '+253', flag: 'dj' },
  { name: 'Dominique', iso2: 'DM', dialCode: '+1 767', flag: 'dm' },
  { name: 'Égypte', iso2: 'EG', dialCode: '+20', flag: 'eg' },
  { name: 'Émirats arabes unis', iso2: 'AE', dialCode: '+971', flag: 'ae' },
  { name: 'Équateur', iso2: 'EC', dialCode: '+593', flag: 'ec' },
  { name: 'Érythrée', iso2: 'ER', dialCode: '+291', flag: 'er' },
  { name: 'Espagne', iso2: 'ES', dialCode: '+34', flag: 'es' },
  { name: 'Estonie', iso2: 'EE', dialCode: '+372', flag: 'ee' },
  { name: 'États-Unis', iso2: 'US', dialCode: '+1', flag: 'us' },
  { name: 'Éthiopie', iso2: 'ET', dialCode: '+251', flag: 'et' },
  { name: 'Fidji', iso2: 'FJ', dialCode: '+679', flag: 'fj' },
  { name: 'Finlande', iso2: 'FI', dialCode: '+358', flag: 'fi' },
  { name: 'France', iso2: 'FR', dialCode: '+33', flag: 'fr' },
  { name: 'Gabon', iso2: 'GA', dialCode: '+241', flag: 'ga' },
  { name: 'Gambie', iso2: 'GM', dialCode: '+220', flag: 'gm' },
  { name: 'Géorgie', iso2: 'GE', dialCode: '+995', flag: 'ge' },
  { name: 'Ghana', iso2: 'GH', dialCode: '+233', flag: 'gh' },
  { name: 'Gibraltar', iso2: 'GI', dialCode: '+350', flag: 'gi' },
  { name: 'Grèce', iso2: 'GR', dialCode: '+30', flag: 'gr' },
  { name: 'Grenade', iso2: 'GD', dialCode: '+1 473', flag: 'gd' },
  { name: 'Groenland', iso2: 'GL', dialCode: '+299', flag: 'gl' },
  { name: 'Guadeloupe', iso2: 'GP', dialCode: '+590', flag: 'gp' },
  { name: 'Guam', iso2: 'GU', dialCode: '+1 671', flag: 'gu' },
  { name: 'Guatemala', iso2: 'GT', dialCode: '+502', flag: 'gt' },
  { name: 'Guernesey', iso2: 'GG', dialCode: '+44', flag: 'gg' },
  { name: 'Guinée', iso2: 'GN', dialCode: '+224', flag: 'gn' },
  { name: 'Guinée équatoriale', iso2: 'GQ', dialCode: '+240', flag: 'gq' },
  { name: 'Guinée-Bissau', iso2: 'GW', dialCode: '+245', flag: 'gw' },
  { name: 'Guyana', iso2: 'GY', dialCode: '+592', flag: 'gy' },
  { name: 'Haïti', iso2: 'HT', dialCode: '+509', flag: 'ht' },
  { name: 'Honduras', iso2: 'HN', dialCode: '+504', flag: 'hn' },
  { name: 'Hong Kong', iso2: 'HK', dialCode: '+852', flag: 'hk' },
  { name: 'Hongrie', iso2: 'HU', dialCode: '+36', flag: 'hu' },
  { name: 'Inde', iso2: 'IN', dialCode: '+91', flag: 'in' },
  { name: 'Indonésie', iso2: 'ID', dialCode: '+62', flag: 'id' },
  { name: 'Irak', iso2: 'IQ', dialCode: '+964', flag: 'iq' },
  { name: 'Iran', iso2: 'IR', dialCode: '+98', flag: 'ir' },
  { name: 'Irlande', iso2: 'IE', dialCode: '+353', flag: 'ie' },
  { name: 'Islande', iso2: 'IS', dialCode: '+354', flag: 'is' },
  { name: 'Israël', iso2: 'IL', dialCode: '+972', flag: 'il' },
  { name: 'Italie', iso2: 'IT', dialCode: '+39', flag: 'it' },
  { name: 'Jamaïque', iso2: 'JM', dialCode: '+1 876', flag: 'jm' },
  { name: 'Japon', iso2: 'JP', dialCode: '+81', flag: 'jp' },
  { name: 'Jersey', iso2: 'JE', dialCode: '+44', flag: 'je' },
  { name: 'Jordanie', iso2: 'JO', dialCode: '+962', flag: 'jo' },
  { name: 'Kazakhstan', iso2: 'KZ', dialCode: '+7', flag: 'kz' },
  { name: 'Kenya', iso2: 'KE', dialCode: '+254', flag: 'ke' },
  { name: 'Kirghizistan', iso2: 'KG', dialCode: '+996', flag: 'kg' },
  { name: 'Kiribati', iso2: 'KI', dialCode: '+686', flag: 'ki' },
  { name: 'Kosovo', iso2: 'XK', dialCode: '+383', flag: 'xk' },
  { name: 'Koweït', iso2: 'KW', dialCode: '+965', flag: 'kw' },
  { name: 'Laos', iso2: 'LA', dialCode: '+856', flag: 'la' },
  { name: 'Lesotho', iso2: 'LS', dialCode: '+266', flag: 'ls' },
  { name: 'Lettonie', iso2: 'LV', dialCode: '+371', flag: 'lv' },
  { name: 'Liban', iso2: 'LB', dialCode: '+961', flag: 'lb' },
  { name: 'Liberia', iso2: 'LR', dialCode: '+231', flag: 'lr' },
  { name: 'Libye', iso2: 'LY', dialCode: '+218', flag: 'ly' },
  { name: 'Liechtenstein', iso2: 'LI', dialCode: '+423', flag: 'li' },
  { name: 'Lituanie', iso2: 'LT', dialCode: '+370', flag: 'lt' },
  { name: 'Luxembourg', iso2: 'LU', dialCode: '+352', flag: 'lu' },
  { name: 'Macao', iso2: 'MO', dialCode: '+853', flag: 'mo' },
  { name: 'Macédoine du Nord', iso2: 'MK', dialCode: '+389', flag: 'mk' },
  { name: 'Madagascar', iso2: 'MG', dialCode: '+261', flag: 'mg' },
  { name: 'Malaisie', iso2: 'MY', dialCode: '+60', flag: 'my' },
  { name: 'Malawi', iso2: 'MW', dialCode: '+265', flag: 'mw' },
  { name: 'Maldives', iso2: 'MV', dialCode: '+960', flag: 'mv' },
  { name: 'Mali', iso2: 'ML', dialCode: '+223', flag: 'ml' },
  { name: 'Malte', iso2: 'MT', dialCode: '+356', flag: 'mt' },
  { name: 'Maroc', iso2: 'MA', dialCode: '+212', flag: 'ma' },
  { name: 'Martinique', iso2: 'MQ', dialCode: '+596', flag: 'mq' },
  { name: 'Mauritanie', iso2: 'MR', dialCode: '+222', flag: 'mr' },
  { name: 'Maurice', iso2: 'MU', dialCode: '+230', flag: 'mu' },
  { name: 'Mayotte', iso2: 'YT', dialCode: '+262', flag: 'yt' },
  { name: 'Mexique', iso2: 'MX', dialCode: '+52', flag: 'mx' },
  { name: 'Micronésie', iso2: 'FM', dialCode: '+691', flag: 'fm' },
  { name: 'Moldavie', iso2: 'MD', dialCode: '+373', flag: 'md' },
  { name: 'Monaco', iso2: 'MC', dialCode: '+377', flag: 'mc' },
  { name: 'Mongolie', iso2: 'MN', dialCode: '+976', flag: 'mn' },
  { name: 'Montserrat', iso2: 'MS', dialCode: '+1 664', flag: 'ms' },
  { name: 'Monténégro', iso2: 'ME', dialCode: '+382', flag: 'me' },
  { name: 'Mozambique', iso2: 'MZ', dialCode: '+258', flag: 'mz' },
  { name: 'Myanmar', iso2: 'MM', dialCode: '+95', flag: 'mm' },
  { name: 'Namibie', iso2: 'NA', dialCode: '+264', flag: 'na' },
  { name: 'Nauru', iso2: 'NR', dialCode: '+674', flag: 'nr' },
  { name: 'Népal', iso2: 'NP', dialCode: '+977', flag: 'np' },
  { name: 'Nicaragua', iso2: 'NI', dialCode: '+505', flag: 'ni' },
  { name: 'Niger', iso2: 'NE', dialCode: '+227', flag: 'ne' },
  { name: 'Nigeria', iso2: 'NG', dialCode: '+234', flag: 'ng' },
  { name: 'Niue', iso2: 'NU', dialCode: '+683', flag: 'nu' },
  { name: 'Norvège', iso2: 'NO', dialCode: '+47', flag: 'no' },
  { name: 'Nouvelle-Calédonie', iso2: 'NC', dialCode: '+687', flag: 'nc' },
  { name: 'Nouvelle-Zélande', iso2: 'NZ', dialCode: '+64', flag: 'nz' },
  { name: 'Oman', iso2: 'OM', dialCode: '+968', flag: 'om' },
  { name: 'Ouganda', iso2: 'UG', dialCode: '+256', flag: 'ug' },
  { name: 'Ouzbékistan', iso2: 'UZ', dialCode: '+998', flag: 'uz' },
  { name: 'Pakistan', iso2: 'PK', dialCode: '+92', flag: 'pk' },
  { name: 'Palaos', iso2: 'PW', dialCode: '+680', flag: 'pw' },
  { name: 'Palestine', iso2: 'PS', dialCode: '+970', flag: 'ps' },
  { name: 'Panama', iso2: 'PA', dialCode: '+507', flag: 'pa' },
  { name: 'Papouasie-Nouvelle-Guinée', iso2: 'PG', dialCode: '+675', flag: 'pg' },
  { name: 'Paraguay', iso2: 'PY', dialCode: '+595', flag: 'py' },
  { name: 'Pays-Bas caribéens', iso2: 'BQ', dialCode: '+599', flag: 'bq' },
  { name: 'Pérou', iso2: 'PE', dialCode: '+51', flag: 'pe' },
  { name: 'Philippines', iso2: 'PH', dialCode: '+63', flag: 'ph' },
  { name: 'Pologne', iso2: 'PL', dialCode: '+48', flag: 'pl' },
  { name: 'Polynésie française', iso2: 'PF', dialCode: '+689', flag: 'pf' },
  { name: 'Porto Rico', iso2: 'PR', dialCode: '+1 787', flag: 'pr' },
  { name: 'Portugal', iso2: 'PT', dialCode: '+351', flag: 'pt' },
  { name: 'Qatar', iso2: 'QA', dialCode: '+974', flag: 'qa' },
  { name: 'République centrafricaine', iso2: 'CF', dialCode: '+236', flag: 'cf' },
  { name: 'République démocratique du Congo', iso2: 'CD', dialCode: '+243', flag: 'cd' },
  { name: 'République dominicaine', iso2: 'DO', dialCode: '+1 809', flag: 'do' },
  { name: 'République du Congo', iso2: 'CG', dialCode: '+242', flag: 'cg' },
  { name: 'République tchèque', iso2: 'CZ', dialCode: '+420', flag: 'cz' },
  { name: 'Réunion', iso2: 'RE', dialCode: '+262', flag: 're' },
  { name: 'Roumanie', iso2: 'RO', dialCode: '+40', flag: 'ro' },
  { name: 'Royaume-Uni', iso2: 'GB', dialCode: '+44', flag: 'gb' },
  { name: 'Russie', iso2: 'RU', dialCode: '+7', flag: 'ru' },
  { name: 'Rwanda', iso2: 'RW', dialCode: '+250', flag: 'rw' },
  { name: 'Saint-Barthélemy', iso2: 'BL', dialCode: '+590', flag: 'bl' },
  { name: 'Saint-Christophe-et-Niévès', iso2: 'KN', dialCode: '+1 869', flag: 'kn' },
  { name: 'Saint-Martin', iso2: 'MF', dialCode: '+590', flag: 'mf' },
  { name: 'Saint-Pierre-et-Miquelon', iso2: 'PM', dialCode: '+508', flag: 'pm' },
  { name: 'Saint-Vincent-et-les-Grenadines', iso2: 'VC', dialCode: '+1 784', flag: 'vc' },
  { name: 'Sainte-Hélène', iso2: 'SH', dialCode: '+290', flag: 'sh' },
  { name: 'Sainte-Lucie', iso2: 'LC', dialCode: '+1 758', flag: 'lc' },
  { name: 'Salvador', iso2: 'SV', dialCode: '+503', flag: 'sv' },
  { name: 'Samoa', iso2: 'WS', dialCode: '+685', flag: 'ws' },
  { name: 'Samoa américaines', iso2: 'AS', dialCode: '+1 684', flag: 'as' },
  { name: 'Saint-Marin', iso2: 'SM', dialCode: '+378', flag: 'sm' },
  { name: 'Sao Tomé-et-Principe', iso2: 'ST', dialCode: '+239', flag: 'st' },
  { name: 'Sénégal', iso2: 'SN', dialCode: '+221', flag: 'sn' },
  { name: 'Serbie', iso2: 'RS', dialCode: '+381', flag: 'rs' },
  { name: 'Seychelles', iso2: 'SC', dialCode: '+248', flag: 'sc' },
  { name: 'Sierra Leone', iso2: 'SL', dialCode: '+232', flag: 'sl' },
  { name: 'Singapour', iso2: 'SG', dialCode: '+65', flag: 'sg' },
  { name: 'Slovaquie', iso2: 'SK', dialCode: '+421', flag: 'sk' },
  { name: 'Slovénie', iso2: 'SI', dialCode: '+386', flag: 'si' },
  { name: 'Somalie', iso2: 'SO', dialCode: '+252', flag: 'so' },
  { name: 'Soudan', iso2: 'SD', dialCode: '+249', flag: 'sd' },
  { name: 'Soudan du Sud', iso2: 'SS', dialCode: '+211', flag: 'ss' },
  { name: 'Sri Lanka', iso2: 'LK', dialCode: '+94', flag: 'lk' },
  { name: 'Suède', iso2: 'SE', dialCode: '+46', flag: 'se' },
  { name: 'Suisse', iso2: 'CH', dialCode: '+41', flag: 'ch' },
  { name: 'Suriname', iso2: 'SR', dialCode: '+597', flag: 'sr' },
  { name: 'Svalbard et Jan Mayen', iso2: 'SJ', dialCode: '+47', flag: 'sj' },
  { name: 'Swaziland', iso2: 'SZ', dialCode: '+268', flag: 'sz' },
  { name: 'Syrie', iso2: 'SY', dialCode: '+963', flag: 'sy' },
  { name: 'Tadjikistan', iso2: 'TJ', dialCode: '+992', flag: 'tj' },
  { name: 'Taïwan', iso2: 'TW', dialCode: '+886', flag: 'tw' },
  { name: 'Tanzanie', iso2: 'TZ', dialCode: '+255', flag: 'tz' },
  { name: 'Tchad', iso2: 'TD', dialCode: '+235', flag: 'td' },
  { name: 'Thaïlande', iso2: 'TH', dialCode: '+66', flag: 'th' },
  { name: 'Timor oriental', iso2: 'TL', dialCode: '+670', flag: 'tl' },
  { name: 'Togo', iso2: 'TG', dialCode: '+228', flag: 'tg' },
  { name: 'Tokelau', iso2: 'TK', dialCode: '+690', flag: 'tk' },
  { name: 'Tonga', iso2: 'TO', dialCode: '+676', flag: 'to' },
  { name: 'Trinité-et-Tobago', iso2: 'TT', dialCode: '+1 868', flag: 'tt' },
  { name: 'Tunisie', iso2: 'TN', dialCode: '+216', flag: 'tn' },
  { name: 'Turkménistan', iso2: 'TM', dialCode: '+993', flag: 'tm' },
  { name: 'Turquie', iso2: 'TR', dialCode: '+90', flag: 'tr' },
  { name: 'Tuvalu', iso2: 'TV', dialCode: '+688', flag: 'tv' },
  { name: 'Ukraine', iso2: 'UA', dialCode: '+380', flag: 'ua' },
  { name: 'Uruguay', iso2: 'UY', dialCode: '+598', flag: 'uy' },
  { name: 'Vanuatu', iso2: 'VU', dialCode: '+678', flag: 'vu' },
  { name: 'Vatican', iso2: 'VA', dialCode: '+379', flag: 'va' },
  { name: 'Venezuela', iso2: 'VE', dialCode: '+58', flag: 've' },
  { name: 'Viêt Nam', iso2: 'VN', dialCode: '+84', flag: 'vn' },
  { name: 'Wallis-et-Futuna', iso2: 'WF', dialCode: '+681', flag: 'wf' },
  { name: 'Yémen', iso2: 'YE', dialCode: '+967', flag: 'ye' },
  { name: 'Zambie', iso2: 'ZM', dialCode: '+260', flag: 'zm' },
  { name: 'Zimbabwe', iso2: 'ZW', dialCode: '+263', flag: 'zw' }
];

export const COUNTRIES_EN = [
  { name: 'Afghanistan', iso2: 'AF', dialCode: '+93', flag: 'af' },
  { name: 'South Africa', iso2: 'ZA', dialCode: '+27', flag: 'za' },
  { name: 'Albania', iso2: 'AL', dialCode: '+355', flag: 'al' },
  { name: 'Algeria', iso2: 'DZ', dialCode: '+213', flag: 'dz' },
  { name: 'Germany', iso2: 'DE', dialCode: '+49', flag: 'de' },
  { name: 'Andorra', iso2: 'AD', dialCode: '+376', flag: 'ad' },
  { name: 'Angola', iso2: 'AO', dialCode: '+244', flag: 'ao' },
  { name: 'Anguilla', iso2: 'AI', dialCode: '+1 264', flag: 'ai' },
  { name: 'Antigua and Barbuda', iso2: 'AG', dialCode: '+1 268', flag: 'ag' },
  { name: 'Saudi Arabia', iso2: 'SA', dialCode: '+966', flag: 'sa' },
  { name: 'Argentina', iso2: 'AR', dialCode: '+54', flag: 'ar' },
  { name: 'Aruba', iso2: 'AW', dialCode: '+297', flag: 'aw' },
  { name: 'Australia', iso2: 'AU', dialCode: '+61', flag: 'au' },
  { name: 'Austria', iso2: 'AT', dialCode: '+43', flag: 'at' },
  { name: 'Azerbaijan', iso2: 'AZ', dialCode: '+994', flag: 'az' },
  { name: 'Bahamas', iso2: 'BS', dialCode: '+1 242', flag: 'bs' },
  { name: 'Bahrain', iso2: 'BH', dialCode: '+973', flag: 'bh' },
  { name: 'Bangladesh', iso2: 'BD', dialCode: '+880', flag: 'bd' },
  { name: 'Barbados', iso2: 'BB', dialCode: '+1 246', flag: 'bb' },
  { name: 'Belarus', iso2: 'BY', dialCode: '+375', flag: 'by' },
  { name: 'Belgium', iso2: 'BE', dialCode: '+32', flag: 'be' },
  { name: 'Belize', iso2: 'BZ', dialCode: '+501', flag: 'bz' },
  { name: 'Benin', iso2: 'BJ', dialCode: '+229', flag: 'bj' },
  { name: 'Bermuda', iso2: 'BM', dialCode: '+1 441', flag: 'bm' },
  { name: 'Bhutan', iso2: 'BT', dialCode: '+975', flag: 'bt' },
  { name: 'Bolivia', iso2: 'BO', dialCode: '+591', flag: 'bo' },
  { name: 'Bosnia and Herzegovina', iso2: 'BA', dialCode: '+387', flag: 'ba' },
  { name: 'Botswana', iso2: 'BW', dialCode: '+267', flag: 'bw' },
  { name: 'Brazil', iso2: 'BR', dialCode: '+55', flag: 'br' },
  { name: 'Brunei', iso2: 'BN', dialCode: '+673', flag: 'bn' },
  { name: 'Bulgaria', iso2: 'BG', dialCode: '+359', flag: 'bg' },
  { name: 'Burkina Faso', iso2: 'BF', dialCode: '+226', flag: 'bf' },
  { name: 'Burundi', iso2: 'BI', dialCode: '+257', flag: 'bi' },
  { name: 'Cambodia', iso2: 'KH', dialCode: '+855', flag: 'kh' },
  { name: 'Cameroon', iso2: 'CM', dialCode: '+237', flag: 'cm' },
  { name: 'Canada', iso2: 'CA', dialCode: '+1', flag: 'ca' },
  { name: 'Cape Verde', iso2: 'CV', dialCode: '+238', flag: 'cv' },
  { name: 'Chile', iso2: 'CL', dialCode: '+56', flag: 'cl' },
  { name: 'China', iso2: 'CN', dialCode: '+86', flag: 'cn' },
  { name: 'Cyprus', iso2: 'CY', dialCode: '+357', flag: 'cy' },
  { name: 'Colombia', iso2: 'CO', dialCode: '+57', flag: 'co' },
  { name: 'Comoros', iso2: 'KM', dialCode: '+269', flag: 'km' },
  { name: 'North Korea', iso2: 'KP', dialCode: '+850', flag: 'kp' },
  { name: 'South Korea', iso2: 'KR', dialCode: '+82', flag: 'kr' },
  { name: 'Costa Rica', iso2: 'CR', dialCode: '+506', flag: 'cr' },
  { name: 'Ivory Coast', iso2: 'CI', dialCode: '+225', flag: 'ci' },
  { name: 'Croatia', iso2: 'HR', dialCode: '+385', flag: 'hr' },
  { name: 'Cuba', iso2: 'CU', dialCode: '+53', flag: 'cu' },
  { name: 'Curaçao', iso2: 'CW', dialCode: '+599', flag: 'cw' },
  { name: 'Denmark', iso2: 'DK', dialCode: '+45', flag: 'dk' },
  { name: 'Djibouti', iso2: 'DJ', dialCode: '+253', flag: 'dj' },
  { name: 'Dominica', iso2: 'DM', dialCode: '+1 767', flag: 'dm' },
  { name: 'Egypt', iso2: 'EG', dialCode: '+20', flag: 'eg' },
  { name: 'United Arab Emirates', iso2: 'AE', dialCode: '+971', flag: 'ae' },
  { name: 'Ecuador', iso2: 'EC', dialCode: '+593', flag: 'ec' },
  { name: 'Eritrea', iso2: 'ER', dialCode: '+291', flag: 'er' },
  { name: 'Spain', iso2: 'ES', dialCode: '+34', flag: 'es' },
  { name: 'Estonia', iso2: 'EE', dialCode: '+372', flag: 'ee' },
  { name: 'United States', iso2: 'US', dialCode: '+1', flag: 'us' },
  { name: 'Ethiopia', iso2: 'ET', dialCode: '+251', flag: 'et' },
  { name: 'Fiji', iso2: 'FJ', dialCode: '+679', flag: 'fj' },
  { name: 'Finland', iso2: 'FI', dialCode: '+358', flag: 'fi' },
  { name: 'France', iso2: 'FR', dialCode: '+33', flag: 'fr' },
  { name: 'Gabon', iso2: 'GA', dialCode: '+241', flag: 'ga' },
  { name: 'Gambia', iso2: 'GM', dialCode: '+220', flag: 'gm' },
  { name: 'Georgia', iso2: 'GE', dialCode: '+995', flag: 'ge' },
  { name: 'Ghana', iso2: 'GH', dialCode: '+233', flag: 'gh' },
  { name: 'Gibraltar', iso2: 'GI', dialCode: '+350', flag: 'gi' },
  { name: 'Greece', iso2: 'GR', dialCode: '+30', flag: 'gr' },
  { name: 'Grenada', iso2: 'GD', dialCode: '+1 473', flag: 'gd' },
  { name: 'Greenland', iso2: 'GL', dialCode: '+299', flag: 'gl' },
  { name: 'Guadeloupe', iso2: 'GP', dialCode: '+590', flag: 'gp' },
  { name: 'Guam', iso2: 'GU', dialCode: '+1 671', flag: 'gu' },
  { name: 'Guatemala', iso2: 'GT', dialCode: '+502', flag: 'gt' },
  { name: 'Guernsey', iso2: 'GG', dialCode: '+44', flag: 'gg' },
  { name: 'Guinea', iso2: 'GN', dialCode: '+224', flag: 'gn' },
  { name: 'Equatorial Guinea', iso2: 'GQ', dialCode: '+240', flag: 'gq' },
  { name: 'Guinea-Bissau', iso2: 'GW', dialCode: '+245', flag: 'gw' },
  { name: 'Guyana', iso2: 'GY', dialCode: '+592', flag: 'gy' },
  { name: 'Haiti', iso2: 'HT', dialCode: '+509', flag: 'ht' },
  { name: 'Honduras', iso2: 'HN', dialCode: '+504', flag: 'hn' },
  { name: 'Hong Kong', iso2: 'HK', dialCode: '+852', flag: 'hk' },
  { name: 'Hungary', iso2: 'HU', dialCode: '+36', flag: 'hu' },
  { name: 'India', iso2: 'IN', dialCode: '+91', flag: 'in' },
  { name: 'Indonesia', iso2: 'ID', dialCode: '+62', flag: 'id' },
  { name: 'Iraq', iso2: 'IQ', dialCode: '+964', flag: 'iq' },
  { name: 'Iran', iso2: 'IR', dialCode: '+98', flag: 'ir' },
  { name: 'Ireland', iso2: 'IE', dialCode: '+353', flag: 'ie' },
  { name: 'Iceland', iso2: 'IS', dialCode: '+354', flag: 'is' },
  { name: 'Israel', iso2: 'IL', dialCode: '+972', flag: 'il' },
  { name: 'Italy', iso2: 'IT', dialCode: '+39', flag: 'it' },
  { name: 'Jamaica', iso2: 'JM', dialCode: '+1 876', flag: 'jm' },
  { name: 'Japan', iso2: 'JP', dialCode: '+81', flag: 'jp' },
  { name: 'Jersey', iso2: 'JE', dialCode: '+44', flag: 'je' },
  { name: 'Jordan', iso2: 'JO', dialCode: '+962', flag: 'jo' },
  { name: 'Kazakhstan', iso2: 'KZ', dialCode: '+7', flag: 'kz' },
  { name: 'Kenya', iso2: 'KE', dialCode: '+254', flag: 'ke' },
  { name: 'Kyrgyzstan', iso2: 'KG', dialCode: '+996', flag: 'kg' },
  { name: 'Kiribati', iso2: 'KI', dialCode: '+686', flag: 'ki' },
  { name: 'Kosovo', iso2: 'XK', dialCode: '+383', flag: 'xk' },
  { name: 'Kuwait', iso2: 'KW', dialCode: '+965', flag: 'kw' },
  { name: 'Laos', iso2: 'LA', dialCode: '+856', flag: 'la' },
  { name: 'Lesotho', iso2: 'LS', dialCode: '+266', flag: 'ls' },
  { name: 'Latvia', iso2: 'LV', dialCode: '+371', flag: 'lv' },
  { name: 'Lebanon', iso2: 'LB', dialCode: '+961', flag: 'lb' },
  { name: 'Liberia', iso2: 'LR', dialCode: '+231', flag: 'lr' },
  { name: 'Libya', iso2: 'LY', dialCode: '+218', flag: 'ly' },
  { name: 'Liechtenstein', iso2: 'LI', dialCode: '+423', flag: 'li' },
  { name: 'Lithuania', iso2: 'LT', dialCode: '+370', flag: 'lt' },
  { name: 'Luxembourg', iso2: 'LU', dialCode: '+352', flag: 'lu' },
  { name: 'Macao', iso2: 'MO', dialCode: '+853', flag: 'mo' },
  { name: 'North Macedonia', iso2: 'MK', dialCode: '+389', flag: 'mk' },
  { name: 'Madagascar', iso2: 'MG', dialCode: '+261', flag: 'mg' },
  { name: 'Malaysia', iso2: 'MY', dialCode: '+60', flag: 'my' },
  { name: 'Malawi', iso2: 'MW', dialCode: '+265', flag: 'mw' },
  { name: 'Maldives', iso2: 'MV', dialCode: '+960', flag: 'mv' },
  { name: 'Mali', iso2: 'ML', dialCode: '+223', flag: 'ml' },
  { name: 'Malta', iso2: 'MT', dialCode: '+356', flag: 'mt' },
  { name: 'Morocco', iso2: 'MA', dialCode: '+212', flag: 'ma' },
  { name: 'Martinique', iso2: 'MQ', dialCode: '+596', flag: 'mq' },
  { name: 'Mauritania', iso2: 'MR', dialCode: '+222', flag: 'mr' },
  { name: 'Mauritius', iso2: 'MU', dialCode: '+230', flag: 'mu' },
  { name: 'Mayotte', iso2: 'YT', dialCode: '+262', flag: 'yt' },
  { name: 'Mexico', iso2: 'MX', dialCode: '+52', flag: 'mx' },
  { name: 'Micronesia', iso2: 'FM', dialCode: '+691', flag: 'fm' },
  { name: 'Moldova', iso2: 'MD', dialCode: '+373', flag: 'md' },
  { name: 'Monaco', iso2: 'MC', dialCode: '+377', flag: 'mc' },
  { name: 'Mongolia', iso2: 'MN', dialCode: '+976', flag: 'mn' },
  { name: 'Montserrat', iso2: 'MS', dialCode: '+1 664', flag: 'ms' },
  { name: 'Montenegro', iso2: 'ME', dialCode: '+382', flag: 'me' },
  { name: 'Mozambique', iso2: 'MZ', dialCode: '+258', flag: 'mz' },
  { name: 'Myanmar', iso2: 'MM', dialCode: '+95', flag: 'mm' },
  { name: 'Namibia', iso2: 'NA', dialCode: '+264', flag: 'na' },
  { name: 'Nauru', iso2: 'NR', dialCode: '+674', flag: 'nr' },
  { name: 'Nepal', iso2: 'NP', dialCode: '+977', flag: 'np' },
  { name: 'Nicaragua', iso2: 'NI', dialCode: '+505', flag: 'ni' },
  { name: 'Niger', iso2: 'NE', dialCode: '+227', flag: 'ne' },
  { name: 'Nigeria', iso2: 'NG', dialCode: '+234', flag: 'ng' },
  { name: 'Niue', iso2: 'NU', dialCode: '+683', flag: 'nu' },
  { name: 'Norway', iso2: 'NO', dialCode: '+47', flag: 'no' },
  { name: 'New Caledonia', iso2: 'NC', dialCode: '+687', flag: 'nc' },
  { name: 'New Zealand', iso2: 'NZ', dialCode: '+64', flag: 'nz' },
  { name: 'Oman', iso2: 'OM', dialCode: '+968', flag: 'om' },
  { name: 'Uganda', iso2: 'UG', dialCode: '+256', flag: 'ug' },
  { name: 'Uzbekistan', iso2: 'UZ', dialCode: '+998', flag: 'uz' },
  { name: 'Pakistan', iso2: 'PK', dialCode: '+92', flag: 'pk' },
  { name: 'Palau', iso2: 'PW', dialCode: '+680', flag: 'pw' },
  { name: 'Palestine', iso2: 'PS', dialCode: '+970', flag: 'ps' },
  { name: 'Panama', iso2: 'PA', dialCode: '+507', flag: 'pa' },
  { name: 'Papua New Guinea', iso2: 'PG', dialCode: '+675', flag: 'pg' },
  { name: 'Paraguay', iso2: 'PY', dialCode: '+595', flag: 'py' },
  { name: 'Caribbean Netherlands', iso2: 'BQ', dialCode: '+599', flag: 'bq' },
  { name: 'Peru', iso2: 'PE', dialCode: '+51', flag: 'pe' },
  { name: 'Philippines', iso2: 'PH', dialCode: '+63', flag: 'ph' },
  { name: 'Poland', iso2: 'PL', dialCode: '+48', flag: 'pl' },
  { name: 'French Polynesia', iso2: 'PF', dialCode: '+689', flag: 'pf' },
  { name: 'Puerto Rico', iso2: 'PR', dialCode: '+1 787', flag: 'pr' },
  { name: 'Portugal', iso2: 'PT', dialCode: '+351', flag: 'pt' },
  { name: 'Qatar', iso2: 'QA', dialCode: '+974', flag: 'qa' },
  { name: 'Central African Republic', iso2: 'CF', dialCode: '+236', flag: 'cf' },
  { name: 'Democratic Republic of the Congo', iso2: 'CD', dialCode: '+243', flag: 'cd' },
  { name: 'Dominican Republic', iso2: 'DO', dialCode: '+1 809', flag: 'do' },
  { name: 'Republic of the Congo', iso2: 'CG', dialCode: '+242', flag: 'cg' },
  { name: 'Czech Republic', iso2: 'CZ', dialCode: '+420', flag: 'cz' },
  { name: 'Réunion', iso2: 'RE', dialCode: '+262', flag: 're' },
  { name: 'Romania', iso2: 'RO', dialCode: '+40', flag: 'ro' },
  { name: 'United Kingdom', iso2: 'GB', dialCode: '+44', flag: 'gb' },
  { name: 'Russia', iso2: 'RU', dialCode: '+7', flag: 'ru' },
  { name: 'Rwanda', iso2: 'RW', dialCode: '+250', flag: 'rw' },
  { name: 'Saint Barthélemy', iso2: 'BL', dialCode: '+590', flag: 'bl' },
  { name: 'Saint Kitts and Nevis', iso2: 'KN', dialCode: '+1 869', flag: 'kn' },
  { name: 'Saint Martin', iso2: 'MF', dialCode: '+590', flag: 'mf' },
  { name: 'Saint Pierre and Miquelon', iso2: 'PM', dialCode: '+508', flag: 'pm' },
  { name: 'Saint Vincent and the Grenadines', iso2: 'VC', dialCode: '+1 784', flag: 'vc' },
  { name: 'Saint Helena', iso2: 'SH', dialCode: '+290', flag: 'sh' },
  { name: 'Saint Lucia', iso2: 'LC', dialCode: '+1 758', flag: 'lc' },
  { name: 'El Salvador', iso2: 'SV', dialCode: '+503', flag: 'sv' },
  { name: 'Samoa', iso2: 'WS', dialCode: '+685', flag: 'ws' },
  { name: 'American Samoa', iso2: 'AS', dialCode: '+1 684', flag: 'as' },
  { name: 'San Marino', iso2: 'SM', dialCode: '+378', flag: 'sm' },
  { name: 'Sao Tome and Principe', iso2: 'ST', dialCode: '+239', flag: 'st' },
  { name: 'Senegal', iso2: 'SN', dialCode: '+221', flag: 'sn' },
  { name: 'Serbia', iso2: 'RS', dialCode: '+381', flag: 'rs' },
  { name: 'Seychelles', iso2: 'SC', dialCode: '+248', flag: 'sc' },
  { name: 'Sierra Leone', iso2: 'SL', dialCode: '+232', flag: 'sl' },
  { name: 'Singapore', iso2: 'SG', dialCode: '+65', flag: 'sg' },
  { name: 'Slovakia', iso2: 'SK', dialCode: '+421', flag: 'sk' },
  { name: 'Slovenia', iso2: 'SI', dialCode: '+386', flag: 'si' },
  { name: 'Somalia', iso2: 'SO', dialCode: '+252', flag: 'so' },
  { name: 'Sudan', iso2: 'SD', dialCode: '+249', flag: 'sd' },
  { name: 'South Sudan', iso2: 'SS', dialCode: '+211', flag: 'ss' },
  { name: 'Sri Lanka', iso2: 'LK', dialCode: '+94', flag: 'lk' },
  { name: 'Sweden', iso2: 'SE', dialCode: '+46', flag: 'se' },
  { name: 'Switzerland', iso2: 'CH', dialCode: '+41', flag: 'ch' },
  { name: 'Suriname', iso2: 'SR', dialCode: '+597', flag: 'sr' },
  { name: 'Svalbard and Jan Mayen', iso2: 'SJ', dialCode: '+47', flag: 'sj' },
  { name: 'Eswatini', iso2: 'SZ', dialCode: '+268', flag: 'sz' },
  { name: 'Syria', iso2: 'SY', dialCode: '+963', flag: 'sy' },
  { name: 'Tajikistan', iso2: 'TJ', dialCode: '+992', flag: 'tj' },
  { name: 'Taiwan', iso2: 'TW', dialCode: '+886', flag: 'tw' },
  { name: 'Tanzania', iso2: 'TZ', dialCode: '+255', flag: 'tz' },
  { name: 'Chad', iso2: 'TD', dialCode: '+235', flag: 'td' },
  { name: 'Thailand', iso2: 'TH', dialCode: '+66', flag: 'th' },
  { name: 'East Timor', iso2: 'TL', dialCode: '+670', flag: 'tl' },
  { name: 'Togo', iso2: 'TG', dialCode: '+228', flag: 'tg' },
  { name: 'Tokelau', iso2: 'TK', dialCode: '+690', flag: 'tk' },
  { name: 'Tonga', iso2: 'TO', dialCode: '+676', flag: 'to' },
  { name: 'Trinidad and Tobago', iso2: 'TT', dialCode: '+1 868', flag: 'tt' },
  { name: 'Tunisia', iso2: 'TN', dialCode: '+216', flag: 'tn' },
  { name: 'Turkmenistan', iso2: 'TM', dialCode: '+993', flag: 'tm' },
  { name: 'Turkey', iso2: 'TR', dialCode: '+90', flag: 'tr' },
  { name: 'Tuvalu', iso2: 'TV', dialCode: '+688', flag: 'tv' },
  { name: 'Ukraine', iso2: 'UA', dialCode: '+380', flag: 'ua' },
  { name: 'Uruguay', iso2: 'UY', dialCode: '+598', flag: 'uy' },
  { name: 'Vanuatu', iso2: 'VU', dialCode: '+678', flag: 'vu' },
  { name: 'Vatican', iso2: 'VA', dialCode: '+379', flag: 'va' },
  { name: 'Venezuela', iso2: 'VE', dialCode: '+58', flag: 've' },
  { name: 'Vietnam', iso2: 'VN', dialCode: '+84', flag: 'vn' },
  { name: 'Wallis and Futuna', iso2: 'WF', dialCode: '+681', flag: 'wf' },
  { name: 'Yemen', iso2: 'YE', dialCode: '+967', flag: 'ye' },
  { name: 'Zambia', iso2: 'ZM', dialCode: '+260', flag: 'zm' },
  { name: 'Zimbabwe', iso2: 'ZW', dialCode: '+263', flag: 'zw' }
];
